import type * as React from 'react';
import { get } from '@Domain/Api';
import accountFetched, {
	type AccountFetchedAction,
	type AccountPayload,
} from '@Application/Accounts/Actions/accountFetched';
import accountFetchFailed, {
	type AccountFetchFailedAction,
} from '@Application/Accounts/Actions/accountFetchFailed';
import type FetchAccount from '@Application/Accounts/Queries/FetchAccount';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AccountFetchedAction | AccountFetchFailedAction;

export default (query: FetchAccount) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<AccountPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}`,
			);

			const action = accountFetched({ id: response.id, name: response.name });
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
